import React from "react";
import { workflowLabel } from "../utils/appAuth";

const WorkflowBadge = ({ record }) => {
  const label = workflowLabel(record);
  if (!label) return null;
  const tone =
    label === "Draft"
      ? "bg-yellow-100 text-yellow-800"
      : label === "Finalized"
        ? "bg-blue-100 text-blue-900"
        : "bg-green-100 text-green-800";
  return (
    <span className={`px-2 py-0.5 text-xs font-semibold rounded-full ${tone}`}>
      {label}
    </span>
  );
};

export default WorkflowBadge;
